/**
 * Theme Name: project-sscms v1.519.0
 * Theme URI: git+https://github.com/1debit/project-sscms.git
 * Author: Sharp Notions, LLC
 * Author URI: https://sharpnotions.com
 * Description: Wordpress theme for Chime (project-sscms) [main - b7cd30e04]
 * Version: 1.519.0-2025-08-13T14-18-27
 * License: ISC
 * License URI: "http://www.gnu.org/licenses/gpl-2.0.html"
 */
/**
 * File floating-disclaimer.js.
 * Handles setting a cookie when floating disclaimer is dismissed
 */

const floatingDisclaimer = document.querySelector('.floating-disclaimer');
const dismissButton = document.querySelector('.floating-disclaimer__dismiss');
const floatingHeroCta = document.querySelector('.hero__cta--floating');

let floatingCtaOptions = {
    threshold: [1]
};

let handleFloatingCta = ([e]) => {
    let atTargetRatio = (e.intersectionRatio < 1 && e.intersectionRatio > 0.99);
    let atViewportBottom = (e.boundingClientRect.top > 0);
    let stickCondition = atTargetRatio && atViewportBottom;
    e.target.classList.toggle('stuck', stickCondition);
    floatingDisclaimer.classList.toggle('floating-disclaimer--cta-above', stickCondition);
};

const floatingHeroObserver = new IntersectionObserver(handleFloatingCta, floatingCtaOptions);

function checkBounding(initTop, scrollListener) {
    // if top position changes, remove floating class, unobserve CTA, remove scroll listener
    if (initTop > floatingHeroCta.getBoundingClientRect().top) {
        removeFloatingClass();
        floatingHeroObserver.unobserve(floatingHeroCta);
        window.removeEventListener('scroll', scrollListener, false);
    }
}

function removeFloatingClass() {
    floatingHeroCta.classList.remove('hero__cta--floating');
}

function disclaimerShown() {
  // If the 'segment' object is defined, execute the following code block
  if (typeof segment !== 'undefined') {
    segment(
      'track',
      'Floating Disclaimer Shown'
    );
  }
}

function disclaimerDismissed() {
  // If the 'segment' object is defined, execute the following code block
  if (typeof segment !== 'undefined') {
    segment(
      'track',
      'Floating Disclaimer Dismissed'
    );
  }
}

function listenForPosition() {
    const initTop = floatingHeroCta.getBoundingClientRect().top;
    
    const scrollListener = function() {
        checkBounding(initTop, scrollListener);
    };
    
    window.addEventListener('scroll', scrollListener, false);
}

function dismiss() {
    floatingDisclaimer.remove();

    if (floatingHeroCta) {
        floatingHeroCta.classList.add('solo');
        listenForPosition();
    }

    disclaimerDismissed();

    // remove inline style from .blog-template__cta-wrapper, which is dynamically added to prevent overlap with floating disclaimer
    let ctaWrapper = document.querySelector('.blog-template__cta-wrapper');
    if (ctaWrapper) ctaWrapper.removeAttribute('style');
}

function dismissKeyDown(event) {
  if (event.key == "Enter") {
    dismiss();
  }
}

// Init
disclaimerShown();
if (dismissButton) {
  dismissButton.addEventListener('click', dismiss);
  dismissButton.addEventListener('keydown', dismissKeyDown);
}
if (floatingHeroCta) floatingHeroObserver.observe(floatingHeroCta);
